import { Timestamp } from "firebase-admin/firestore";
import { DocumentGradedState } from "~/types/enums/DocumentGradedState.enum";
import { DocumentState } from "./enums/DocumentState";
import { DocumentSubmissionType } from "./enums/DocumentSubmissionType.enum";

export type SubmittedDocument = {
  id?: string;
  createOnTimestamp: number;
  earnedPoints?: number;
  lastUpdatedTimestamp: number;
  maxPoints?: number;
  name: string;
  fileType?: string;
  enteredName?: string;
  state: DocumentState;
  userId: string;
  profileId?: string;
  userProfileId?: string;
  teacherUserId?: string;
  classroomName?: string;
  classroomId?: string;
  studentName?: string;
  studentId?: string;
  assignmentName?: string;
  assignmentId?: string;
  allowFinalDraftGradedState?: boolean;
  studentSubmissionId?: string;
  levelId?: string;
  levelName?: string;
  lessonId?: string;
  lessonName?: string;
  externalId?: string; // This could be something like the sakai submission Id
  gradeableId?: string;
  externalStatus?: string;
  isLate: boolean;
  dueTime?: number;
  dueTimestamp?: Timestamp;
  submittedAtTimestamp?: Timestamp;
  submittedAtTimestampMillis?: number;
  startGradingAtTimestamp?: number;
  finishedGradingAtTimestamp?: number;
  checklistId?: string;
  checklistPath?: string;
  doesNOTExpectAssignment: boolean;
  demoId?: string;
  isSample: boolean;
  sampleDisplayOrder?: number;
  documentSubmissionType?: DocumentSubmissionType;
  documentGradedState?: DocumentGradedState;
  googleDriveFileId?: string;
  tours?: {
    id: string;
    isComplete: boolean;
    type: "dialog" | "checklist-button";
  }[];
  optionalTours?: string[];
  originalDocumentId?: string;
  hasValidatedDocument?: boolean;
  shouldCopyFullDocument?: boolean;
  isReturnedToStudent?: boolean;
  inkColor?: number[];

  // Assignment Specific settings
  assignmentOpenTimestamp?: number;
  assignmentDueTimestamp?: number;
  assignmentCloseTimestamp?: number;
  assignmentIsVisibleToStudents?: boolean;
  assignmentAllowKWOSubmission?: boolean;
  assignmentAllowRoughDraftSubmission?: boolean;
  assignmentRequiredKWOSubmission?: boolean;
  assignmentRequireRoughDraftSubmission?: boolean;
  assignmentRequireRoughDraftChecklist?: boolean;
  assignmentRoughDraftSubmissionFormats?: string[];
  assignmentAllowFinalDraftSubmission?: boolean;
  assignmentAllowFinalDraftGradedState?: boolean;
  assignmentIsAutoReturnEnabled?: boolean;
  assignmentType?: AssignmentType;

  // Classroom Specific settings
  enableStudentReview?: boolean;
  enableSubmissionBadges?: boolean;
  enableStudentSubmissionCreation?: boolean;
  enableStudentCompare?: boolean;
  enableStudentThesaurus?: boolean;

  numAssessmentAttempts?: number;
  badge?: SubmittedDocumentBadge;
  submissionSeal?: SubmittedDocumentBadge;
  assignmentLevelId?: string;
  assignmentLessonId?: string;
  originalFileMediaHref?: string;

  studentGuidedReviewStepIndex?: number;
};

export type SubmittedDocuments = SubmittedDocument[];

export enum SubmittedDocumentBadge {
  gold = "gold",
  silver = "silver",
  bronze = "bronze",
}
